"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var movingAndTrading = {
  id: "movingAndTrading",
  title: {
    en: "Moving and trading",
    de: "Bewegen und Handeln"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Moving item and trading"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Looting window\u2192inventory"), "Click on wanted item then drop the item at the empty spot. Drag wanted item with your mouse then R_click(mouse right click))")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Market"), "Take item from your inventory and the Right click, then it will be sold.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "1on1 trade with non user"), "Select trader and at the chatting window/ register trade by clicking Ctrl key and click, then through trade menu you can trade."))))
  }
};
var _default = movingAndTrading;
exports.default = _default;